<template>
	<section>
		<div :class="isMobile ? '' : 'mb-100'">
			<template v-if="isKB">
				<PartnerKBBanner />
			</template>
			<template v-else>
				<EduUnivBanner :univ="partner.name" />
			</template>
		</div>

		<GridLayout>
			<c-new-col>
				<!-- 진행중인 계약 파트너일때만 노출 -->
				<div v-if="isProgressing" class="b2b-edu-notice clearfix">
					<div class="b2b-edu-notice-box b2b-edu-notice-left">
						<PartnerNoticeLeft :partner="partner" />
					</div>
					<div class="b2b-edu-notice-box b2b-edu-notice-right">
						<c-box :paddings="noticeBoxRightPaddings" backgroundColor="gray000" style="overflow: hidden">
							<ul class="b2b-edu-notice-box-list float-left">
								<li
									v-for="(notice, index) in noticeItem"
									:key="`notice${index}`"
									class="b2b-edu-notice-box-list-item"
								>
									<c-typography
										type="body1"
										color="gray900"
										:font-weight="600"
										class="b2b-edu-notice-box-list-item-title"
									>
										{{ notice.title }}
									</c-typography>
									<c-typography
										class="b2b-edu-notice-box-list-item-text"
										type="body2"
										color="gray850"
									>
										<c-typography v-purify-html="notice.item" element="span" />
										<a
											v-if="notice.link"
											:href="$_notionHrefFormat(notice.link.url)"
											target="_blank"
											v-html="notice.link.text"
										/>
										<c-typography
											v-if="notice.caption"
											class="mt-4"
											type="caption1"
											color="gray500"
										>
											{{ notice.caption }}
										</c-typography>
									</c-typography>

									<c-typography
										v-if="notice.firstComeText"
										class="mt-32"
										type="body2"
										color="gray600"
									>
										* 선착순에 따라 모집이 조기 마감될 수 있습니다.
									</c-typography>
								</li>
							</ul>
							<div
								class="b2b-edu-notice-box-list float-right apply-item"
								:style="isKB && !isMobile ? 'width:276px' : ''"
							>
								<div v-for="list in applyItem" :key="list.title" class="b2b-edu-notice-box-list-item">
									<c-typography
										type="body1"
										color="gray900"
										:font-weight="600"
										class="b2b-edu-notice-box-list-item-title"
									>
										{{ list.title }}
									</c-typography>
									<c-box
										v-for="(item, index) in list.item"
										:key="`item${index}`"
										:paddings="[14, 12, 14, 12]"
										backgroundColor="white"
										:hasBorder="true"
										borderColor="gray200"
									>
										<span class="mr-8">{{ index + 1 }}</span>
										<div class="b2b-edu-notice-box-list-item-text-container">
											<c-typography
												v-purify-html="item"
												class="b2b-edu-notice-box-list-item-text"
												type="body2"
												color="gray850"
											/>
											<c-typography
												v-if="list.caption && list.caption[index]"
												type="caption1"
												color="gray500"
											>
												{{ list.caption[index] }}
											</c-typography>
										</div>
									</c-box>
								</div>
							</div>
						</c-box>
					</div>
				</div>

				<!--총 검색건수-->
				<div v-if="isLoaded" class="h7 flex flex-between flex-v-middle" :class="isMobile ? 'mb-16' : 'mb-24'">
					<c-typography v-if="isEmptyData(clickedCategories)" type="headline5" color="gray900">
						{{ computedTitle }}
					</c-typography>
					<template v-else>
						<c-typography
							v-for="category in clickedCategories"
							:key="category"
							type="caption1"
							color="gray500"
							class="mr-10"
						>
							#{{ category }}
						</c-typography>
					</template>
					<div v-show="count !== null && isLoaded" class="inline-block">총 {{ count }}건</div>
				</div>

				<div v-if="parseInt(count) !== 0">
					<!--캠프-->
					<EduCard :campList="removePartnerNameCampList" :partner="partner" class="mb-40" />
				</div>

				<infinite-loading
					ref="infiniteLoadingEdu"
					:identifier="infiniteId"
					force-use-infinite-wrapper="true"
					@infinite="infiniteHandlerEdu"
				>
					<span slot="no-more"></span>
					<span slot="no-results">
						<div
							v-show="isCampListEmpty"
							class="empty-box flex flex-column flex-v-middle flex-center"
							:class="isMobile ? 'mb-88' : 'mb-100'"
						>
							<img class="empty-img" src="/images/empty.svg" alt="검색결과없음 이미지" />
							<div class="text-center">
								<div>일치하는 캠프가 없습니다.</div>
								<div>
									더 많은 캠프를 보고 싶다면
									<CustomLink to="/edu/list" class="text-link">여기</CustomLink>를 클릭해주세요!
								</div>
							</div>
						</div>
					</span>
				</infinite-loading>
			</c-new-col>
		</GridLayout>
		<PartnerKBAd v-if="isKB && !isMobile" />
		<GridLayout v-if="isFinishList && campList.length > 0" grid-color="gray100" grid-fluid>
			<c-typography class="py-32" type="headline7" align="center" :font-weight="300" style="width: 100%">
				원하는 캠프가 없으신가요?<br />
				<c-typography element="span" color="blue600">
					<CustomLink to="/edu/list" class="text-link" target="_blank">여기</CustomLink>
				</c-typography>
				에서 모든 캠프를 볼 수 있어요.(유료)
			</c-typography>
		</GridLayout>
	</section>
</template>

<script>
import eduCampMixin from '../../../../mixins/edu/eduCamp';
import partnerMixin from '../../../../mixins/partnerMixin';
import EduCard from '../../../../components/edu/EduCard.vue';
import PartnerKBBanner from '../../../../components/b2b/partner/edu/PartnerKBBanner.vue';
import PartnerNoticeLeft from '../../../../components/b2b/partner/edu/PartnerNoticeLeft.vue';
import PartnerKBAd from '../../../../components/b2b/partner/edu/PartnerKBAd.vue';
import GridLayout from '../../../../components/common/GridLayout.vue';
import CustomLink from '../../../../components/common/CustomLink.vue';
import EduUnivBanner from '@/views/b2b/partner/edu/EduUnivBanner.vue';

export default {
	mixins: [eduCampMixin, partnerMixin],
	props: ['isLogin', 'userNo', 'userType', 'ord', 'userId', 'keyword', 'category'],
	data: () => ({
		campList: [],
		isSearch: false,
		page: 1,
		limit: 9,
		infiniteId: +new Date(),
		isLoaded: false,
		classType: {
			// 0: '오프라인',
			1: '온라인',
			// 2: '온라인VOD',
			// 2: '원데이',
		},
		isClassTypeClicked: false,
		isCampListEmpty: false,
		isFinishList: false,
		cdn: 'https://d3oho2by66df6p.cloudfront.net/univ_banner/edu/edu_',
		isCollapsed: false,
		count: null,
		topCategories: [], // 필터 - 대분류 직무
		clickedCategories: [], // 클릭한 카테고리들
	}),
	computed: {
		computedTitle() {
			if (!this.isSmartUsg) return '지금 지원 가능한 캠프';
			if (this.isMobile) {
				return '울산∙경남지역 재학생 전액무료!';
			}
			return '[재학생 전액무료] 경남대∙경상국립대∙영산대∙울산대∙인제대∙창원대';
		},
		removePartnerNameCampList() {
			return this.campList.map(camp => {
				// [KB국민은행X광진구청], [관악구청] 등....
				camp.title = camp.title.replace(/\[.*\] /g, '');
				return camp;
			});
		},
		noticeBoxRightPaddings() {
			if (this.isMobile) {
				return [24, 24, 24, 24];
			} else {
				return [56, 56, 56, 56];
			}
		},
		isProgressing() {
			return (
				this.isRootImpact || this.isGreenNewDeal || this.isDongjak || this.isKB || this.isSba || this.isHanyang
			);
		},
		noticeItem() {
			let notices = [
				{
					title: '직무부트캠프란?',
					item: '현직자 멘토와 함께 인턴처럼 기업의 실무를 5주간 체험하는 <br class="only-pc" />직무교육 프로그램으로 코멘토가 운영합니다.',
				},
				{
					title: '혜택',
					item: '직무부트캠프 교육비 전액 지원 (30만원 상당)',
				},
			];
			if (this.isRootImpact) {
				const subject = {
					title: '대상',
					item: '취업 취약계층',
					link: {
						text: '(상세 자격요건 조회하기)',
						url: 'https://www.notion.so/comento/1743ae99594d4256ba2a352818dc2e02',
					},
					firstComeText: true,
				};
				notices.push(subject);
			}
			if (this.isKB) {
				const subject = {
					title: '대상',
					item: '만 19 ~39세 서울시 청년구직자',
					caption: '*서울시 광진구 거주자 또는 관내 대학생 우대',
					firstComeText: false,
				};
				notices.push(subject);
			}
			if (this.isSba) {
				const subject = {
					title: '대상',
					item: '주민등록등본상 거주지가 서울 시민인 자',
					caption: '* SBA 교육과정 SeSAC 수료생 우대',
					firstComeText: false,
				};
				notices.push(subject);
			}
			if (this.isHanyang) {
				const subject = {
					title: '대상',
					item: '한양대학교 재학생',
					firstComeText: false,
				};
				notices.push(subject);
			}
			return notices;
		},
		applyItem() {
			if (this.isRootImpact) {
				return [
					{
						title: '신청 절차',
						item: ['직무부트캠프 참여 신청', '예치금 입급 (수료시 100% 환급)', '직무부트캠프 참여'],
					},
				];
			} else if (this.isKB) {
				return [
					{
						title: '모집 기간 및 신청 절차',
						item: ['직무부트캠프 참여 신청', '신청서 심사 후 선발', '사전 설명회', '직무부트캠프 참여'],
						caption: ['(5월 31일 마감)', '(6월 08일 선발)', '(6월 15일 진행)'],
					},
				];
			} else {
				return [
					{
						title: '신청 절차',
						item: ['직무부트캠프 참여 신청', '신청서류 확인 후 선발', '직무부트캠프 참여'],
						caption: ['', '', ''],
					},
				];
			}
		},
	},
	beforeCreate() {
		this.$store.state.searchOption = '캠프';
	},
	beforeDestroy() {
		this.showModal = false;
	},
	created() {
		this.isCampListEmpty = false;
		this.isLoaded = true;
		if (!this.isEmptyData(this.keyword)) {
			this.$store.state.keyword = this.keyword;
			this.isSearch = true;
		}
		sessionStorage.setItem('partnerInfo', JSON.stringify(this.partner));
	},
	mounted() {
		//GTM - viewEduList_B2B
		viewEduList_B2B(
			this.userNo,
			this.userType,
			this.userId,
			this.comentoLocalStorageId,
			window.location.href,
			'B2B',
		);
	},
	methods: {
		campImg(name) {
			let trans = name;
			if (!this.isMobile) {
				trans = 'pc_' + trans;
			}
			return 'https://cdn.comento.kr/edu/' + trans;
		},
		goUnivPage() {
			window.location.href = '/edu/univ/' + this.partner.url;
		},
		infiniteHandlerEdu($state) {
			this.isCampListEmpty = false;

			/*
			 * category: [
			 *     { top_category: ['연구개발'] },
			 *     { mid_category: ['기구개발', '연구개발'] }
			 * ]
			 * */
			let category = [];
			if (this.isJumpUp) {
				category.push({ type: ['jump-up'] });
			}

			let params = {
				keyword: '',
				page: this.page,
				limit: this.limit,
				partner: this.partner.url,
				category,
			};

			if (this.isSearch) {
				params.keyword = this.keyword;
			}

			axios({
				method: 'GET',
				url: '/api/edu/search',
				params,
			})
				.then(response => {
					const data = response.data;

					if (data.code === 200) {
						if (data.list.list.length >= 1) {
							const campListToShow = data.list.list.filter(camp => camp.running !== 0);
							this.campList.push(...campListToShow);
							this.page += 1;
							this.isLoaded = true;
							this.isFinishList = false;
							this.count = data.list.count;
							$state.loaded();
						} else {
							this.isLoaded = true;
							this.isFinishList = true;
							this.isCampListEmpty = true;
							$state.complete();
						}
					}
				})
				.catch(error => {
					console.log(error);
					$state.complete();
				});
		},
		init() {
			this.isCampListEmpty = false;
			this.campList = [];
			this.page = 1;
			this.infiniteId += 1;
			this.isLoaded = false;
		},
		clickCampRequestBanner() {
			// GTM - clickCampRequestButton
			clickCampRequestButton(this.userNo, this.userType, this.userId, this.comentoLocalStorageId);
			window.open('/edu/request');
		},
	},
	components: {
		EduUnivBanner,
		CustomLink,
		GridLayout,
		PartnerNoticeLeft,
		EduCard,
		PartnerKBBanner,
		PartnerKBAd,
	},
};
</script>

<style lang="less" scoped>
@phone: 480px;
@border-color: #e1e4e7;
@caption-color: #9ea5ab;
@border-color: #e1e4e7;
@bg-btn-color-gray: #f4f5f7;

//직부캠 B2B
.univ {
	&.top-banner {
		height: 300px;
		@media (max-width: @phone) {
			height: 250px;
		}
	}

	.index-headline {
		font-size: 52px;
		font-weight: bold;
		line-height: 90px;
		color: #ffffff;
	}

	.container,
	&-contents {
		height: calc(100% - 8px);
	}

	&-contents {
		position: relative;
		&-container {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 100%;
		}
	}

	.index-subline {
		font-size: 34px;
		font-weight: normal;
		line-height: 50px;
		text-align: center;
		color: #f8f9fa;
		letter-spacing: -1px;
	}
}

.b2b-edu-notice {
	border: 1px solid #e8eaed;
	margin-bottom: 40px;
	border-radius: 10px;
	overflow: hidden;
	::v-deep &-box {
		position: relative;
		&-list {
			overflow: hidden;
			&-item {
				display: block;
				+ .b2b-edu-notice-box-list-item {
					margin-top: 32px;
				}
				.b2b-edu-notice-box-list-item-text-container {
					display: flex;
					align-items: center;
					justify-content: space-between;
				}
				&-title {
					margin-bottom: 4px;
				}
				&-text {
					a {
						color: #1e90ff;
					}
				}
			}
			&.apply-item {
				width: 240px;
				.c-box {
					span {
						display: inline-block;
						width: 16px;
						line-height: 16px;
						background: #2a7de1;
						font-size: 9px;
						border-radius: 16px;
						text-align: center;
						color: #fff;
						margin: 2px 4px 0 0;
						float: left;
					}
					+ .c-box {
						margin-top: 8px;
					}
				}
				.b2b-edu-notice-box-list-item-title {
					margin-bottom: 8px;
				}
			}
		}
	}
	::v-deep &-left {
		width: 373/1140 * 100%;
		float: left;
	}
	::v-deep &-right {
		width: 767/1140 * 100%;
		float: right;
	}

	@media (max-width: @phone) {
		margin-left: -15px;
		margin-right: -15px;
		border: 0;
		::v-deep &-box {
			&-caption {
				position: absolute;
				left: 24px;
				bottom: 24px;
			}
			width: 100% !important;
			&-list {
				&-item {
					+ .b2b-edu-notice-box-list-item {
						margin-top: 48px;
					}
				}
				&.apply-item {
					margin-top: 48px;
					width: 100%;
				}
			}
		}
	}
}
</style>
